const currencyFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

interface FormatCurrencyOptions {
  prefix?: string;
  includePrefix?: boolean;
  withSpace?: boolean;
}

export const formatCurrency = (
  value: number,
  { prefix = 'RM', includePrefix = true, withSpace = false }: FormatCurrencyOptions = {}
): string => {
  const formattedNumber = currencyFormatter.format(value);

  if (!includePrefix) {
    return formattedNumber;
  }

  const space = withSpace ? ' ' : '';
  return `${prefix}${space}${formattedNumber}`;
};


